import template from './_form.pug'

export default Vue.extend({
  template: template(),
  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSaving: false,
      errors: {
        typology: null,
        typologyMapping: null
      },
      form: {
        typology: '',
        level1: null,
        level2: null,
        isContact: null,
        isSale: null,
        isEffectiveContact: null,
        isClosed: null,
        usage: '',
        status: null,
        isNonManageableNonContacted: null,
        isNonManageableContacted: null,
        isManageableNonContacted: null,
        isManageableContacted: null,
        typologyMapping: ''
      },
      level1Options: [
        { value: 'CNU', label: 'CNU' },
        { value: 'CU+', label: 'CU+' },
        { value: 'CU-', label: 'CU-' },
        { value: 'SIN TIPIFICAR', label: 'SIN TIPIFICAR' }
      ],
      level2Options: [
        { value: 'GESTIONABLES', label: 'GESTIONABLES' },
        { value: 'NO GESTIONABLES', label: 'NO GESTIONABLES' },
        { value: 'SIN TIPIFICAR', label: 'SIN TIPIFICAR' }
      ],
      statusOptions: [
        { value: 'CONTACTADO', label: 'CONTACTADO' },
        { value: 'NO CONTACTADO', label: 'NO CONTACTADO' }
      ],
      yesNoOptions: [
        { value: 1, label: 'Si' },
        { value: 0, label: 'No' }
      ]
    }
  },
  watch: {
    initialData: {
      handler(newData) {
        if (newData && Object.keys(newData).length) {
          const cleanData = newData.data || newData;
          
          const numericFields = [
            'isContact', 'isSale', 'isEffectiveContact', 'isClosed', 
            'isNonManageableNonContacted', 'isNonManageableContacted', 
            'isManageableNonContacted', 'isManageableContacted'
          ];

          Object.keys(this.form).forEach(key => {
            if (cleanData[key] !== undefined && cleanData[key] !== null) {
              
              if (numericFields.includes(key)) {
                const parsed = parseInt(cleanData[key], 10);
                this.form[key] = isNaN(parsed) ? null : parsed;
              } else {
                this.form[key] = cleanData[key];
              }
              
            }
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'call-status-mappings-index' });
    },
    validate() {
      let isValid = true;
      this.errors = { typology: null, typologyMapping: null };
      
      if (!this.form.typology || this.form.typology.toString().trim() === '') {
        this.errors.typology = 'Este campo es obligatorio';
        isValid = false;
      }
      if (!this.form.typologyMapping || this.form.typologyMapping.toString().trim() === '') {
        this.errors.typologyMapping = 'Este campo es obligatorio';
        isValid = false;
      }
      return isValid;
    },
    submit() {
      if (!this.validate()) return;
      
      this.isSaving = true;

      const payload = { ...this.form };

      const recordId = this.$route.params.id || this.initialData.id || (this.initialData.data && this.initialData.data.id);

      const apiCall = this.isEdit 
        ? API.callStatusMappings.update(recordId, payload) 
        : API.callStatusMappings.create(payload);

      apiCall.then(() => {
        this.$notifications.success(this.isEdit ? 'Codificación actualizada exitosamente' : 'Codificación creada exitosamente');
        this.$router.push({ name: 'call-status-mappings-index' });
      }).catch(error => {
        console.error("Error guardando codificación: ", error);
        this.$notifications.error('Ocurrió un error al intentar guardar los datos');
      }).finally(() => {
        this.isSaving = false;
      });
    }
  }
})